import { __assign } from "tslib";
import { createHttpTestKit } from './../http/test-kit';
import { createWorkflowsApi } from '.';
import { createFakeDeleteResponder, createFakeGetResponder, createFakePostResponder, createFakePutResponder } from './../test-utils';
export var createWorkflowsApiTestKit = function () {
    var fakeHttp = createHttpTestKit();
    var api = createWorkflowsApi('', fakeHttp);
    var testKit = {
        whenGetAll: function () {
            return createFakeGetResponder(fakeHttp, '/recipes');
        },
        whenGet: function (recipeId) {
            return createFakeGetResponder(fakeHttp, "/recipes/" + recipeId);
        },
        whenAddScenario: function (dto) {
            return createFakePostResponder(fakeHttp, '/recipes')(dto === '*' ? '*' : __assign(__assign({}, dto), { disabled: false }));
        },
        whenDeleteScenario: function (scenarioId) {
            return createFakeDeleteResponder(fakeHttp, "/recipes/" + scenarioId);
        },
        whenUpdateScenario: function (scenario) {
            return createFakePutResponder(fakeHttp, scenario === '*' ? '*' : "/recipes/" + scenario.id)(scenario);
        },
        whenEnableScenario: function (scenarioId) {
            return createFakePutResponder(fakeHttp, "/recipes/" + scenarioId + "/enable")({});
        },
        whenDisableScenario: function (scenarioId) {
            return createFakePutResponder(fakeHttp, "/recipes/" + scenarioId + "/disable")({});
        },
        whenGetEmailTemplatePreview: function (dto) {
            return createFakePostResponder(fakeHttp, dto === '*' ? dto : "/recipes/notification/" + dto.recipeType + "/preview")(dto);
        }
    };
    return __assign(__assign({}, api), testKit);
};
//# sourceMappingURL=testkit.js.map